import { render, staticRenderFns } from "./OnAdjustment.vue?vue&type=template&id=2c3c0847"
import script from "./OnAdjustment.vue?vue&type=script&lang=js"
export * from "./OnAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports